import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AllocationService } from 'src/app/api/services';
import { TraysService } from 'src/app/api/services/trays.service';

@Component({
  selector: 'app-showcase-picture-dialog',
  templateUrl: './showcase-picture-dialog.component.html',
  styleUrls: ['./showcase-picture-dialog.component.scss']
})
export class ShowcasePictureDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<ShowcasePictureDialogComponent>,
    public traysService: TraysService
  ) { }

  closeDialog(): void {
    this.traysService.showShowcasePictureDialog$.next(false);
    this.dialogRef.close();
  }
}
